import { Component } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
export interface LiteratureDocumentListingComponent {
  selectRow: (event, isFromSelectAll: boolean, isSelect: boolean) => void;
  isMaxLimitReached(): boolean;
}

export interface SelectAllParams extends ICellRendererParams {
  reference?: LiteratureDocumentListingComponent;
}

@Component({
  selector: 'ft-select-all-group-header',
  templateUrl: './select-all-group-header.component.html',
  styleUrls: ['./select-all-group-header.component.scss'],
})
export class SelectAllGroupHeaderComponent {
  params: SelectAllParams;
  parentComponent: LiteratureDocumentListingComponent;
  isSelected = false;
  constructor() {}

  agInit(params: SelectAllParams) {
    this.params = params;
    this.parentComponent = params.reference;
    this.isSelected = this.parentComponent.isMaxLimitReached();
  }

  onSelectAllClick(event: PointerEvent) {
    this.isSelected = !this.isSelected;
    this.parentComponent.selectRow(this.params, true, this.isSelected);
  }
}
